import { render, staticRenderFns } from "./Clicksign.vue?vue&type=template&id=0a52279e&"
import script from "./Clicksign.vue?vue&type=script&lang=js&"
export * from "./Clicksign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports